(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["erides-compare-ui"] && !Shopify.designMode) return;
  try {
    (() => {
    const storageKey = 'erides-compare-rides-v1';
    const limit = 3;
    const shell = document.querySelector('[data-erides-compare-shell]');
    if (!shell || shell.dataset.ready === 'true') return;
    shell.dataset.ready = 'true';

    const bar = shell.querySelector('[data-erides-compare-bar]');
    const chips = shell.querySelector('[data-erides-compare-chips]');
    const count = shell.querySelector('[data-erides-compare-count]');
    const status = shell.querySelector('[data-erides-compare-status]');
    const openButton = shell.querySelector('[data-erides-compare-open]');
    const clearButton = shell.querySelector('[data-erides-compare-clear]');
    const dialog = shell.querySelector('[data-erides-compare-dialog]');
    const results = shell.querySelector('[data-erides-compare-results]');
    let selected = [];

    const read = () => {
      try {
        const value = JSON.parse(localStorage.getItem(storageKey) || '[]');
        return Array.isArray(value) ? value.slice(0, limit) : [];
      } catch (error) {
        return [];
      }
    };

    const write = () => {
      try { localStorage.setItem(storageKey, JSON.stringify(selected)); } catch (error) { return; }
    };

    const productFromButton = (button) => ({
      id: button.dataset.productId,
      title: button.dataset.productTitle,
      url: button.dataset.productUrl,
      image: button.dataset.productImage,
      price: button.dataset.productPrice,
      tags: button.dataset.productTags || '',
      description: button.dataset.productDescription || ''
    });

    const first = (text, expressions) => {
      for (const expression of expressions) {
        const match = text.match(expression);
        if (match) return match[1].replace(/\s+/g, ' ').trim();
      }
      return '–';
    };

    const specs = (item) => {
      const tags = item.tags.split('||');
      const source = tags.join(' | ') + ' | ' + item.description;
      const motor = first(source, [
        /([\d'’.,]+\s*[x×]\s*[\d'’.,]+\s*(?:Watt|W)(?!h))/i,
        /([\d'’.,]+\s*[-–‑]?\s*(?:Watt|W)(?!h))/i
      ]);
      const speedTag = tags.find((tag) => /km\/h/i.test(tag));
      const rangeTag = tags.find((tag) => /reichweite/i.test(tag));
      const voltTag = tags.find((tag) => /\b\d+(?:[.,]\d+)?\s*V\b/i.test(tag));
      const ampTag = tags.find((tag) => /\b\d+(?:[.,]\d+)?\s*Ah\b/i.test(tag));
      const wattHourTag = tags.find((tag) => /\b\d+(?:[.,]\d+)?\s*Wh\b/i.test(tag));
      return {
        motor: motor,
        speed: speedTag || first(source, [/(?:bis zu\s*)?([\d'’.,]+\s*km\/h)/i]),
        range: rangeTag || first(source, [/reichweite(?: von)?(?: bis zu)?\s*([\d'’.,]+\s*km)/i, /bis zu\s*([\d'’.,]+\s*km)(?!\/h)/i]),
        battery: [voltTag, ampTag].filter(Boolean).join(' / ') || '–',
        energy: wattHourTag || first(source, [/([\d'’.,]+\s*Wh)\b/i])
      };
    };

    const syncButtons = () => {
      document.querySelectorAll('[data-erides-compare-add]').forEach((button) => {
        const active = selected.some((item) => item.id === button.dataset.productId);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        const label = button.querySelector('[data-erides-compare-label]');
        const nextLabel = active ? 'Ausgewählt' : 'Vergleichen';
        if (label && label.textContent !== nextLabel) label.textContent = nextLabel;
      });
    };

    const renderBar = () => {
      bar.hidden = selected.length === 0;
      count.textContent = selected.length + ' von ' + limit + ' ausgewählt';
      openButton.disabled = selected.length < 2;
      chips.replaceChildren();
      selected.forEach((item) => {
        const chip = document.createElement('div');
        chip.className = 'erides-compare-chip';
        const label = document.createElement('span');
        label.textContent = item.title;
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.dataset.removeCompareId = item.id;
        remove.setAttribute('aria-label', item.title + ' entfernen');
        remove.textContent = '×';
        chip.append(label, remove);
        chips.append(chip);
      });
      syncButtons();
    };

    const addCell = (grid, value, className) => {
      const cell = document.createElement('div');
      cell.className = 'erides-compare-cell ' + (className || '');
      cell.textContent = value;
      grid.append(cell);
    };

    const renderDialog = () => {
      const grid = document.createElement('div');
      grid.className = 'erides-compare-grid';
      grid.style.gridTemplateColumns = 'minmax(150px,.7fr) repeat(' + selected.length + ',minmax(190px,1fr))';
      addCell(grid, 'Modell', 'erides-compare-cell--label');

      selected.forEach((item) => {
        const head = document.createElement('div');
        head.className = 'erides-compare-cell erides-compare-cell--head';
        if (item.image) {
          const image = document.createElement('img');
          image.src = item.image;
          image.alt = item.title;
          image.loading = 'lazy';
          head.append(image);
        }
        const title = document.createElement('strong');
        title.textContent = item.title;
        const price = document.createElement('span');
        price.textContent = item.price;
        head.append(title, price);
        grid.append(head);
      });

      const itemSpecs = selected.map(specs);
      [
        ['Motorleistung', 'motor'],
        ['Geschwindigkeit', 'speed'],
        ['Reichweite', 'range'],
        ['Akku', 'battery'],
        ['Energiegehalt', 'energy'],
        ['Preis', 'price']
      ].forEach((row) => {
        addCell(grid, row[0], 'erides-compare-cell--label');
        selected.forEach((item, index) => {
          addCell(grid, row[1] === 'price' ? item.price : itemSpecs[index][row[1]], 'erides-compare-cell--value');
        });
      });

      addCell(grid, 'Produktseite', 'erides-compare-cell--label');
      selected.forEach((item) => {
        const cell = document.createElement('div');
        cell.className = 'erides-compare-cell erides-compare-cell--link';
        const link = document.createElement('a');
        link.href = item.url;
        link.textContent = 'RIDE ANSEHEN';
        cell.append(link);
        grid.append(cell);
      });

      results.replaceChildren(grid);
    };

    const setStatus = (message) => {
      status.textContent = message;
      window.clearTimeout(setStatus.timer);
      setStatus.timer = window.setTimeout(() => { status.textContent = ''; }, 3200);
    };

    selected = read();
    renderBar();

    document.addEventListener('click', (event) => {
      const addButton = event.target.closest('[data-erides-compare-add]');
      if (addButton) {
        event.preventDefault();
        const item = productFromButton(addButton);
        const index = selected.findIndex((entry) => entry.id === item.id);
        if (index >= 0) {
          selected.splice(index, 1);
        } else if (selected.length >= limit) {
          setStatus('Du kannst maximal drei Rides gleichzeitig vergleichen.');
          return;
        } else {
          selected.push(item);
        }
        write();
        renderBar();
        return;
      }

      const removeButton = event.target.closest('[data-remove-compare-id]');
      if (removeButton) {
        selected = selected.filter((item) => item.id !== removeButton.dataset.removeCompareId);
        write();
        renderBar();
      }
    });

    clearButton.addEventListener('click', () => {
      selected = [];
      write();
      renderBar();
    });

    openButton.addEventListener('click', () => {
      if (selected.length < 2) return;
      renderDialog();
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    });

    shell.querySelector('[data-erides-compare-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    const observer = new MutationObserver(syncButtons);
    observer.observe(document.body, { childList:true, subtree:true });
  })();
  } catch(e) { console.error(e); }
})();

})();
